// 微博授权，微信授权，微信扫码登录时，应该都需要回跳到某一页面，所以出现成功和失败走实例化构造函数时传入的success和error函数
// res返回一个对象：{status: 'success/fail', data: {'一个对象，放返回的数据'}, message: '返回的提示信息'}，添加或修改方法时也按照这种格式返回
import ajax from '../utils/ajax'
const isDyh = location.origin.indexOf('www.2021chengdu.com') !== -1 || location.origin.indexOf('testuni.msvoicepower.com') !== -1 || location.origin.indexOf('preview.msvoicepower.com') !== -1
// 目前只有大运会会用到这个id ，因为 涉及项目多，统一管理；其他应用自己传id过来
const appid = {
  'test': {
    WECHAT_APP_ID: 'wx0af26ab650783f9e', // PC微信扫码登录
    MOBILE_WECHAT_APP_ID: 'wx22a300e4f8cf65f2',  // 公众号授权登录
    WE_CLIENT_ID: '3560468130', // 微博client_id
    WB_APP_ID: '336568847', // 微博id
    QQ_APP_ID: '101863804', // qq登录id
    FB_APP_ID: '2891589687752362', // facebok的appid
    GG_APP_ID: '123456', // google登录 会用后端来做的appid 前端目前传没用
    INS_APP_ID: '336040198040301' //instagram 登录id
  },
  'preview': {
    WECHAT_APP_ID: 'wx42ea2ed3c742ab1c', // PC微信扫码登录
    MOBILE_WECHAT_APP_ID: 'wx713dedfd2ce9753d', // 公众号授权登录
    WE_CLIENT_ID: '3560468130', // 正微博client_id
    WB_APP_ID: '3560468130', // 微博id
    QQ_APP_ID: '101863804', // qq登录id
    FB_APP_ID: '2891589687752362', // 正式facebok的appid
    GG_APP_ID: '123456',  //google登录 会用后端来做的appid 前端目前传没用
    INS_APP_ID: '336040198040301' //instagram 登录id
  },
  'line': {
    WECHAT_APP_ID: 'wx42ea2ed3c742ab1c', // PC微信扫码登录
    MOBILE_WECHAT_APP_ID: 'wx713dedfd2ce9753d', // 公众号授权登录
    WE_CLIENT_ID: '3560468130', // 正微博client_id
    WB_APP_ID: '3560468130', // 微博id
    QQ_APP_ID: '101863804', // qq登录id
    FB_APP_ID: '2891589687752362', // 正式facebok的appid
    GG_APP_ID: '123456',  //google登录 会用后端来做的appid 前端目前传没用
    INS_APP_ID: '336040198040301' //instagram 登录id
  }
}
var appKey = location.origin.indexOf('www.2021chengdu.com') !== -1 ? 'line' : (location.origin.indexOf('preview.msvoicepower.com')!== -1 ? 'preview' : 'test')
export default class yrLogin {
  constructor(params = {}) {
    let { fieldName = '' } = params

    if (!fieldName) {
      console.error('fieldName必须o')
      return;
    }
    this.init(params)
    this.checkHasLogged()
  }

  init(params = {}) { // 初始化，并且储存信息
    let { fieldName, baseUrl, success, error } = params;
    this.version = '0.0.1'
    this.fieldName = fieldName
    // baseUrl -- 请求域名或者域名加路径 如：http://testwww.universiade.buerkongjian.com/chengduapi
    this.apiList = {
      getAuthUrl: baseUrl + '/v1/auth/auth-url', // 获取授权地址
      getToken:baseUrl + '/v1/auth/call-back', // 授权后使用code换取token
      getOfficialToken: baseUrl + '/v1/auth/official-call-back', // 公众号授权后使用code换取token
      getUserInfo: baseUrl + '/v1/base/users/user-info', // 使用token获取用户信息
      getTokenByAccessToken: baseUrl + '/v1/auth/get-user-token', // 通过facebook的accesstoken获取token
      getXcxToken: baseUrl + '/appletsH5/v1/authorizes/get', // h5内嵌小程序授权后使用code换取token
      loginout: baseUrl + '/v1/auth/token-failure', // 退出登录
      getAuthUrlNew: baseUrl + '/v1/wx/auth-url', // 微信里面其他登录方式绑定微信
      getTokenNew: baseUrl + '/v1/wx/call-back', // 微信里面其他登录方式绑定微信
    }

    this.successFun = success || function () { }
    this.errorFun = error || function () { }
    sessionStorage.invitationCode = this.getQueryString('invitationCode') || sessionStorage.invitationCode || ''
  }

  login(type, params) {
    console.log('login', type, params)
    // 登录之前先清空保存的信息
    this.logout();
    // 不同的登录类型会带上不同的authType
    this[type](params);
    console.log('login type',type,params,this)
  }

  logout(callback,code='') {
    sessionStorage.removeItem('user-uid')
    sessionStorage.removeItem('all-uid')
    if(code === 401 || !isDyh){
      localStorage.removeItem(this.fieldName)
      callback && callback()
    } else {
      this.ajaxGet({
        url: this.apiList.loginout,
        data: {},
        success: (res) => {
          localStorage.removeItem(this.fieldName)
          callback && callback()
        },
        error: (err) => {
          if(err === '401') {
            localStorage.removeItem(this.fieldName)
            callback && callback()
          }
        }
      })
    }
  }

  getInfo(key) { // 取出用户信息
    let data = localStorage[this.fieldName]
    if (!data) {
      return null
    }

    if (key) {
      var u = navigator.userAgent
      data = JSON.parse(data)[key]
      // console.log('==data=', data)
      if(key==='userMsg' &&  u.match(/MicroMessenger/i) && isDyh && data && !data.is_wx_web_auth) {
        this.toAuthUrlNew()
      }
      return data
    }
    console.log('---2')
    return JSON.parse(data)
  }

  setInfo(key, value) { // 修改信息
    let data = localStorage[this.fieldName], localObj;

    if (!data) { // 为空时
      localObj = Object.create(null) // 赋值为空对象
    } else {
      localObj = JSON.parse(data)
    }

    localObj[key] = value
    localStorage[this.fieldName] = JSON.stringify(localObj)
    // setCookie(key, value)
  }

  setCookie(cname, cvalue) {
    if(cname === 'token') {
      cname = 'Token'
    }
    let curHost = location.host.split('.')
    var domain = `domain=.${curHost[curHost.length-2]}.${curHost[curHost.length-1]}`
    console.log(cname + "=" + cvalue + "; " + domain);
    document.cookie = cname + "=" + cvalue + "; " + domain;
  }

  checkHasLogged(success, error) { // 检测当前页面是否处于已登录状态（通过code判断）
    let code = this.getQueryString('code'),
      authType = localStorage.authType,
      appId = localStorage.authAppId,
      yr_call_back_token = this.getQueryString('yr_call_back_token'),
      is_third = this.getQueryString('is_third'),
      state = this.getQueryString('state'),
      scope = this.getQueryString('scope'),
      icode = sessionStorage.getItem('invitationCode') || '',
      params;

    
    localStorage.authAppId = ''
    if('weixinAuthSatic' === authType) {
      params = {
        appid:appId,
        code,
        scope,
        state,
        signature: this.getQueryString('signature'),
      }
      this.ajaxGet({ // 使用code换取token
        url:this.apiList.getTokenNew,
        data: params,
        success: (res) => {
          this.getUserInfo(res.data.token || res.data, params)
        },
        error: (err) => {
          this.errorFun(this, {
            status: 'fail',
            data: err,
            message: '获取token错误'
          })
        }
      })
      return
    }
    // 这里对google 做兼容处理 
    if (this.getInfo('token')) { // 已存在token
      localStorage.authType = ''
      this.successFun(this) // 写入完成
      return
    }
    if (yr_call_back_token) { // 如果返回了这个字段--大运会那边使用facebook/qq登录
      localStorage.authType = ''
      this.getUserInfo(yr_call_back_token)
      return;
    }
    if (!code || !authType || !appId) { // 没有token也不处于回调的页面
      localStorage.authType = ''
      this.successFun(this) // 写入完成
      return
    }
    // 检测到code，开始走已登录流程
    // 区分参数，走上报
    params = {
      code,
      appId,
      icode
    }
    sessionStorage.removeItem('invitationCode')
    switch (authType) {
      case 'weixinQrcode':
        params.channel = 'wx_web'
        break;
      case 'weixinAuth':
        params.channel = 'wx'
        break;
      case 'weiboAuth':
        params.channel = 'weibo'
        break;
      case 'facebookAuth':
        params.url = sessionStorage.fbAuthUrl
        params.state = state
        sessionStorage.removeItem('fbAuthUrl')
        break;
      case 'googleAuth':
        params.type = 'google'
        break;
      case 'instagram':
        params.type = 'instagram'
        break
      default:
        break;
    }

    this.ajaxGet({ // 使用code换取token
      url: is_third === 'false' ? this.apiList.getOfficialToken : this.apiList.getToken,
      data: params,
      success: (res) => {
        this.getUserInfo(res.data.token || res.data, params)
      },
      error: (err) => {
        this.errorFun(this, {
          status: 'fail',
          data: err,
          message: '获取token错误'
        })
      }
    })
  }
 
  // 使用token换取用户信息--手机号登录后拿到token换取用户信息
  getUserInfo(token, params = {}) {
    let { success, error, type } = params

    this.setInfo('token', token)
    

    this.ajaxGet({
      url: this.apiList.getUserInfo,
      success: (res) => {

        this.setInfo('userMsg', res.data)
        // console.log('localStorage.authType=',localStorage.authType)
        var u = navigator.userAgent
        // console.log('localStorage.authType=',localStorage.authType)
        // console.log('localStorage.authType=',u.match(/MicroMessenger/i))
        // console.log('localStorage.authType=',res.data.is_wx_web_auth)
        var u = navigator.userAgent
        if(u.match(/MicroMessenger/i) && isDyh && !res.data.is_wx_web_auth) {
          this.toAuthUrlNew()
          return;
        }
        localStorage.authType = ''
        // 去掉code之后的参数
        let valiable;
        if (location.href.indexOf('yr_call_back_token') != -1) {
          valiable = location.href.split("&yr_call_back_token=")[0]
          valiable = valiable.split("?yr_call_back_token=")[0]
        }
        if(type ==='dyh_app') {
          location.reload()
        }else {
          
          valiable = location.href.split("&authType=")[0]
          valiable = valiable.split("?authType=")[0]
          top.location.replace(valiable)
          // window.history.replaceState({}, 0, valiable)
        }
        

        if (success) { // 单独调用采用传入的callback
          success({
            status: 'success',
            data: this.getInfo(),
            message: '存取用户信息成功'
          })
        } else { // 使用默认的callback
          this.successFun(this) // 写入完成
        }
      },
      error: (err) => {
        if (error) {
          error({
            status: 'fail',
            data: err,
            message: '获取用户信息错误'
          })
        } else {
          this.errorFun(this, {
            status: 'fail',
            data: err,
            message: '获取用户信息错误'
          })
        }
      }
    })
  }

  authSure(type, authType, redirect_uri, appId, back_url, is_third,scope){
    if (!appId) {
      console.error('appid必须')
      return;
    }
    redirect_uri = this.setUrl(redirect_uri,['code'])
    back_url = this.setUrl(back_url,['code'])
    let params = {
      type: type,
      url: encodeURIComponent(redirect_uri),
      client_id: appId,
      is_third: is_third,
      appId,
      scope
    }
    localStorage.authType = authType
    localStorage.authAppId = appId
    this.toAuthUrl(params)
  }
  /**
 * 删除URL中指定search参数,会将参数值一起删除
 * @param {string} url 地址字符串
 * @param {array} aParam 要删除的参数key数组，如['name','age']
 * @return {string} 返回新URL字符串
 */
  ridUrlParam(url,aParam){
    aParam.forEach(item => {
      const fromindex = url.indexOf(`${item}=`) //必须加=号，避免参数值中包含item字符串
      if (fromindex !== -1) {
        // 通过url特殊符号，计算出=号后面的的字符数，用于生成replace正则
        const startIndex = url.indexOf('=', fromindex)
        const endIndex = url.indexOf('&', fromindex)
        const hashIndex = url.indexOf('#', fromindex)
        
        let reg;
        if (endIndex !== -1) { // 后面还有search参数的情况
          const num = endIndex - startIndex
          reg = new RegExp(`${item}=.{${num}}`)
          url = url.replace(reg, '')
        } else if (hashIndex !== -1) { // 有hash参数的情况
          const num = hashIndex - startIndex - 1
          reg = new RegExp(`&?${item}=.{${num}}`)
          url = url.replace(reg, '')
        } else { // search参数在最后或只有一个参数的情况
          reg = new RegExp(`&?${item}=.+`)
          url = url.replace(reg, '')
        }
      }
    });
    const noSearchParam = url.indexOf('=') 
    if( noSearchParam === -1 ){
      url = url.replace(/\?/, '') // 如果已经没有参数，删除？号
    }
    return url    
  }
  setUrl(url,aParam){
    let flag = true
    while(flag){
      url = this.ridUrlParam(url,aParam)
      if(url.indexOf('?code=') === -1 && url.indexOf('&code=') === -1){
        flag = false
      }
    }
    return url
  }

  weiboAuth({ redirect_uri = location.href, appId = appid[appKey]['WB_APP_ID'], back_url = location.href }) {
    if (redirect_uri.indexOf('?') != -1) {
      redirect_uri += `&authType=weiboAuth&appId=${appId}`
    } else {
      redirect_uri += `?authType=weiboAuth&appId=${appId}`
    }
    this.authSure('weibo','weiboAuth',redirect_uri,appId,back_url,true,'')
  }

  weixinAuth({ redirect_uri = location.href, client_id = 0, scope = 'snsapi_userinfo', appId = appid[appKey]['MOBILE_WECHAT_APP_ID'] , back_url = location.href, is_third = true }) {
    // 保存原页面地址
    if (redirect_uri.indexOf('?') != -1) {
      redirect_uri += `&authType=weixinAuth&appId=${appId}&is_third=${is_third}`
    } else {
      redirect_uri += `?authType=weixinAuth&appId=${appId}&is_third=${is_third}`
    }
    this.authSure('weixin','weixinAuth',redirect_uri,appId,back_url,is_third,scope)
  }

  weixinQrcode({ redirect_uri = location.href, scope = 'snsapi_login', appId = appid[appKey]['WECHAT_APP_ID'], back_url = location.href }) { // pc微信扫码登录
    if (redirect_uri.indexOf('?') != -1) {
      redirect_uri += `&authType=weixinQrcode&appId=${appId}`
    } else {
      redirect_uri += `?authType=weixinQrcode&appId=${appId}`
    }
    this.authSure('wechat_web','weixinQrcode',redirect_uri,appId,back_url,true,scope)
  }

  qqAuth({ redirect_uri = location.href, client_id = 0, appId = appid[appKey]['QQ_APP_ID'], back_url = location.href, is_third=true }) {
    if (redirect_uri.indexOf('?') != -1) {
      redirect_uri += `&authType=qqAuth&appId=${appId}&is_third=${is_third}`
    } else {
      redirect_uri += `?authType=qqAuth&appId=${appId}&is_third=${is_third}`
    }
    this.authSure('qq','qqAuth',redirect_uri,appId,back_url,is_third,'')
  }

  facebookAuth({ redirect_uri = location.href, client_id = 0, appId = appid[appKey]['FB_APP_ID'], back_url = location.href, is_third = true }) {
    sessionStorage.fbAuthUrl = encodeURIComponent(redirect_uri)
    sessionStorage.yr_login_back_url = back_url
    this.authSure('facebook', 'facebookAuth', redirect_uri, appId,back_url, is_third, '')
  }

  instagramAuth({ redirect_uri = location.href, client_id = 0, appId = appid[appKey]['INS_APP_ID'], back_url = location.href, is_third = true }) {
    sessionStorage.yr_login_back_url = back_url
    this.authSure('instagram', 'instagram', redirect_uri, appId,back_url, is_third, '')
  }

  googleAuth({ redirect_uri = location.href, client_id = 0, appId = appid[appKey]['GG_APP_ID'], back_url = location.href, is_third = true }) {
    sessionStorage.yr_login_back_url = back_url
    this.authSure('google', 'googleAuth', redirect_uri, appId,back_url, is_third, '')
  }

  // h5网页内进行App登录
  appAuth({code,success=()=>{},error=()=>{}}) {
    this.ajaxGet({
      url: this.apiList.getAuthUrl,
      data: {
        type: 'dyh_app',
        client_id: code
      },
      success: (res) => {
        // window.location.href = res.data.authUrl || res.data
        console.log('appAuth success  res',res)
        if(res.data && res.data.token) {
          this.getUserInfo(res.data.token, { success: success,type: 'dyh_app' })
        }else {
          error({
            status: 'fail',
            data: res.data,
            message: '授权失败'
          })
        }
      },
      error: (err) => {
        console.log('appAuth error',err)
        error({
          status: 'fail',
          data: err,
          message: '获取授权地址错误'
        })
      }
    })
  }


  xcxAuth(params) {
    console.log('==xcx-login=', params.code)
    ajax.post({ // 使用code换取token
      url: this.apiList.getXcxToken,
      data: { code: params.code },
      success: (res) => {
        this.getUserInfo(res.data.token, { success: params.callback })
      },
      error: (err) => {
        this.errorFun(this, err)
      }
    })
  }

  toAuthUrl(params) { // 获取授权地址
    this.ajaxGet({
      url: this.apiList.getAuthUrl,
      data: params,
      success: (res) => {
        window.location.href = res.data.authUrl || res.data
      },
      error: (err) => {
        this.errorFun(this, {
          status: 'fail',
          data: err,
          message: '获取授权地址错误'
        })
      }
    })
  }
  toAuthUrlNew() { // 获取授权地址
    let redirect_uri = location.href
    if (redirect_uri.indexOf('?') != -1) {
      redirect_uri += `&authType=weixinAuthSatic`
    } else {
      redirect_uri += `?authType=weixinAuthSatic`
    }
    localStorage.authAppId = appid[appKey]['MOBILE_WECHAT_APP_ID']
    localStorage.authType = 'weixinAuthSatic'
    this.ajaxGet({
      url: this.apiList.getAuthUrlNew,
      data: {
        appId: appid[appKey]['MOBILE_WECHAT_APP_ID'],
        url: encodeURIComponent(redirect_uri),
      },
      success: (res) => {
        console.log('====res==',res.data.authUrl)
        window.location.href = res.data.authUrl || res.data
      },
      error: (err) => {
        this.errorFun(this, {
          status: 'fail',
          data: err,
          message: '获取授权地址错误'
        })
      }
    })
  }

  ajaxGet({ url, data, success, error }) { // get方式请求数据
    let ajax = new XMLHttpRequest(), that = this;

    if (data) {
      url += '?'
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          const item = data[key]
          url += `&${key}=${item}`
        }
      }
    }

    ajax.open('get', url)
    ajax.setRequestHeader('mid', localStorage.mid||'')
    ajax.setRequestHeader('lang', sessionStorage.lang)
    ajax.setRequestHeader('content-type', 'application/x-www-form-urlencoded')
    ajax.setRequestHeader('X-ACCESS-TOKEN', this.getInfo('token'))

    ajax.send()

    ajax.onreadystatechange = () => {
      // console.log('errr==',ajax.status)
      if (ajax.readyState == 4 && ajax.status == 200) {
        success && success(JSON.parse(ajax.responseText))
      }

      if(ajax.status === 401) {
        error && error('401')
      }

      if (ajax.readyState == 4 && ajax.status == 500 && ajax.responseText) {
        // 返回错误信息
        let errMsg = JSON.parse(ajax.responseText)
        error && error(errMsg.message || `${url}请求错误`)
      } else if (ajax.readyState == 4 && ajax.status != 200) {
        error && error(`${url}请求错误`)
      }
    }
  }

  getUUID() {
    return 'xxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    })
  }

  getQueryString(name) {
    const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    const reg_rewrite = new RegExp('(^|/)' + name + '/([^/]*)(/|$)', 'i');
    const r = window.location.search.substr(1).match(reg);
    const q = window.location.pathname.substr(1).match(reg_rewrite);
    if (r != null) {
      return unescape(r[2])
    } else if (q != null) {
      return unescape(q[2])
    } else {
      return ''
    }
  }
  getUrlString(url, name) {
    url = unescape(url)
    let search = url.split('?')[1] || ''
    if (search) {
      let target = search.split('&').find(it => it.indexOf(name) != -1)
      if (target) {
        return target.split('=')[1]
      }
    }
  }
}